// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1VyU_","modalForm":"UpgradeEpcsModal_modalForm__-8dJ3","modalFooter":"UpgradeEpcsModal_modalFooter__3xM6p"};